var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 9C13.125 8.78399 13.0491 8.59389 12.8888 8.42972L6.19939 1.73329C6.05598 1.57776 5.8704 1.5 5.65107 1.5C5.21242 1.5 4.875 1.83698 4.875 2.28629C4.875 2.51094 4.96779 2.70104 5.10276 2.84793L11.2439 9L5.10276 15.1521C4.96779 15.299 4.875 15.4977 4.875 15.7137C4.875 16.163 5.21242 16.5 5.65107 16.5C5.8704 16.5 6.05598 16.4222 6.19939 16.2753L12.8888 9.57028C13.0491 9.41475 13.125 9.21601 13.125 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.56aebe9dd54f48f6ca8b7d9effd715d1.svg";
export { ForwardRef as ReactComponent };